import React, { useContext } from 'react';
import './UsersModule.css';
import { CrudUsers } from '../../Components/Cruds/CrudUsers';
import { useEffect, useState } from 'react';
import { getUserPermissionsByUserEmail } from '../../api/usersModule/getters';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import AccessDeniedPage from '../AccessDeniedPage/AccessDeniedPage';
import UserContext from '../../utils/Contexts/UserContext';

const moduleName = 'Modulo de usuarios';
export const UsersModule = () => {
	const [userPermissions, setUserPermissions] = useState([]);
	const [loading, setLoading] = useState(true);
	const user = useContext(UserContext);

	const getPermissions = async () => {
		setLoading(true);
		let permissions = {
			Consultar: false,
			Crear: false,
			Editar: false,
			Eliminar: false,
		};
		try {
			permissions = await getUserPermissionsByUserEmail(
				user.attributes['email'],
				user.attributes['custom:project'],
				moduleName
			);
			setUserPermissions(permissions);

			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	};

	useEffect(() => {
		getPermissions();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{userPermissions && userPermissions['Consultar'] ? (
				<>
					<div className='bigContainer pt-4 pb-4'>
						<div
							className='children'
							style={{
								width: '90%',
								overflowY: 'auto',
							}}
						>
							<CrudUsers
								userName={user.attributes.family_name}
								permissions={userPermissions}
								project={user.attributes['custom:project']}
							/>
						</div>
					</div>
				</>
			) : loading ? (
				<LoadingPage />
			) : (
				<AccessDeniedPage />
			)}
		</>
	);
};
